import { useEffect, useState } from "react";
import axios from "axios";
import { Spinner } from "@heroui/spinner";

export default function StockQuoteTabContent({ stockSymbol }) {
  // Initialize state variables for stock data
  const [open, setOpen] = useState();
  const [previousClose, setPreviousClose] = useState();
  const [priceAvg50, setPriceAvg50] = useState();
  const [volume, setVolume] = useState();
  const [avgVolume, setAvgVolume] = useState();
  const [symbol, setSymbol] = useState();
  const [name, setName] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchStockData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(
          "/api/company/stock",
          { ticker: stockSymbol },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 200 && response.data.length > 0) {
          const data = await response.data;
          const stockInfo = data[0];

          setSymbol(stockInfo.symbol);
          setOpen(stockInfo.open);
          setPreviousClose(stockInfo.previousClose);
          setPriceAvg50(stockInfo.priceAvg50);
          setVolume(stockInfo.volume);
          setAvgVolume(stockInfo.avgVolume);
          setName(stockInfo.name);
        }
        setIsLoading(false);

      } catch (error) {
        console.error("Error fetching stock data:", error);
      }
    };

    fetchStockData();
  }, [stockSymbol]);

  const formatVolume = (vol) => {
    if(vol !== undefined && vol !== null){
      return vol.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return 'N/A';
  };

  // Loading condition
  if (
    isLoading
  ) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <>
    {!isLoading && !symbol ? (
      <div className="flex justify-center items-center h-full">
        <div className="text-center">No data available for this stock</div>
      </div>
    ) : (<div>
      {/* Repeat the following structure for each line as needed */}
      <div className="font-bold">{symbol}</div>
      <div className="flex mt-3  items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2  text-md">${open}</div>
      </div>
      <div className="text-left font-semibold text-sm">Open:</div>

      <div className="flex mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">${previousClose}</div>
      </div>
      <div className="text-left font-semibold text-sm">Previous Close:</div>

      <div className="flex mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">${priceAvg50}</div>
      </div>
      <div className="text-left font-semibold text-sm">Price Avg 50:</div>

      <div className="flex mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{formatVolume(volume)}</div>
      </div>
      <div className="text-left font-semibold text-sm">Volume:</div>

      <div className="flex  mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{formatVolume(avgVolume)}</div>
      </div>
      <div className="text-left font-semibold mb-3 text-sm">Avg Volume:</div>
    </div>)

    }
    </>
    
  );
}
